import { t } from "../i18n/en";

export type MapSizeFilter = 0 | 2 | 3 | 4;
const ORDER: MapSizeFilter[] = [0, 2, 3, 4];
const STORAGE_KEY = "flight-radar:map-size-filter";

/** Remembered per device. Guarded: storage can be unavailable (private mode) or hold anything. */
export function loadSizeFilter(): MapSizeFilter {
  try {
    const raw = Number(localStorage.getItem(STORAGE_KEY));
    return ORDER.includes(raw as MapSizeFilter) ? (raw as MapSizeFilter) : 0;
  } catch {
    return 0;
  }
}

export function saveSizeFilter(value: MapSizeFilter) {
  try {
    localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Not remembered, which is fine — it still applies for this session.
  }
}

/**
 * One chip that cycles All → Airliners+ → Wide-body → Four-engine. One rather than four: at phone
 * width the top bar already holds the status pill and search.
 */
export default function SizeFilterChip({ value, onChange }: { value: MapSizeFilter; onChange: (v: MapSizeFilter) => void }) {
  const next = ORDER[(ORDER.indexOf(value) + 1) % ORDER.length];
  return (
    <button
      className={`pill pill-button${value ? " pill-active" : ""}`}
      onClick={() => onChange(next)}
      aria-label={t.radar.sizeFilterAria(t.radar.sizeFilter[value])}
    >
      {t.radar.sizeFilter[value]}
    </button>
  );
}
